import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSwitch',
  setup(__props) {

const CustomSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/CustomSwitch.vue"))
const IconsSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/IconsSwitch.vue"))
const UncheckedSwitch = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/UncheckedSwitch.vue"))
const BordersIcons = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/BordersIcons.vue"))
const DisabledOutline = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/DisabledOutline.vue"))
const VariationSwitches = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/VariationSwitches.vue"))
const SwitchSizing = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/SwitchSizing.vue"))
const SwitchIcons = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/switch/SwitchIcons.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(CustomSwitch)),
      _createVNode(_unref(IconsSwitch)),
      _createVNode(_unref(UncheckedSwitch)),
      _createVNode(_unref(BordersIcons)),
      _createVNode(_unref(DisabledOutline)),
      _createVNode(_unref(VariationSwitches)),
      _createVNode(_unref(SwitchSizing)),
      _createVNode(_unref(SwitchIcons))
    ])
  ]))
}
}

})